// extracted by mini-css-extract-plugin
export default {"lsr_conclusion_title":"UZIFnBXb7mayb0pU7LJJ","lsr_conclusion_introduction_wrapper":"zTcHUsB3I8Xigfs0aGMZ","lsr_conclusion_introduction_text":"qzNsXl5QCpSiG4wi50B2"};